import React, { useEffect, useState, useCallback } from "react";
import {
  DetailDrawer,
  InnoTable,
  Loader,
  Popover,
  TableList,
  Tabs,
} from "InnoUI/components";
import SC from "./style";
import theme from "@theme";
import { useSelector } from "react-redux";
import { apiGet } from "api/callApi";
import { useNavigate } from "react-router";
import {
  formatDateTime,
  innoTableConfig,
  innoTableConfigsecond,
  InnoTableDefaultPageSize,
} from "utils/config";
import { selectOccupant } from "@store/occupant/actions";
import { useDispatch } from "react-redux";
import { projectType } from "utils/lookUpTable";
import TimezoneConverter from "components/TimeZoneConvertor";
import CustomTabs from "InnoUI/components/CustomTabs";
import { useSearchParams } from "react-router-dom";
import { decryptCrypto } from "utils/helper";

const OccupantLevels = (props) => {
  const {
    popupState,
    setSelectedSubLevel = {},
    selectedSubLevel,
    setLevelImage,
    setProjectLevelCount = () => {},
  } = props;
  const [projectsLevel, setProjectsLevel] = useState([]);
  const [tabData, setTabData] = useState([]);
  const [occupant, setOccupant] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const deafultLevel = searchParams.get("levelId");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(InnoTableDefaultPageSize.pageSize);

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || []
  );

  const getAllProjectsLevel = useCallback(async () => {
    try {
      setLoading(true);
      const response = await apiGet(`/v1/${currentProject.id}/levels`, false);
      const totalData = response.data;

      setProjectsLevel(totalData);
      setProjectLevelCount(totalData);
      const tabs = totalData.map((level, index) => ({
        value: level.id,
        label: level.name,
        image: level.image,
      }));
      setTabData(tabs);

      if (deafultLevel) {
        const defaultTabLevel = tabs.find((tab) => tab.value == deafultLevel);
        if (defaultTabLevel) {
          setSelectedSubLevel(defaultTabLevel);
          setLevelImage(defaultTabLevel.image);
        } else {
          setSelectedSubLevel(tabs[0]);
          setLevelImage(tabs[0].image);
        }
      } else {
        setSelectedSubLevel(tabs[0]);
        setLevelImage(tabs[0].image);
      }

      setLoading(false);
    } catch (error) {
      console.log("Error fetching project levels:", error);
      setLoading(false);
    }
  }, [currentProject.id]);

  const getAllOccupant = useCallback(async (levelId) => {
    try {
      setLoading(true);
      const response = await apiGet(`/v1/occupant/${levelId}`, false);
      setOccupant(response.data);
      setLoading(false);
    } catch (error) {
      console.log("Error fetching occupants:", error);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getAllProjectsLevel();
  }, [getAllProjectsLevel]);

  useEffect(() => {
    if (selectedSubLevel?.value) {
      getAllOccupant(selectedSubLevel?.value);
    }
  }, [selectedSubLevel]);

  const handleTabChange = (event, item) => {
    setSelectedSubLevel(item);
    getAllOccupant(item.value);

    if (item?.image) {
      setLevelImage(item?.image);
    } else {
      setLevelImage(null);
    }
  };

  const handleClick = (occupantData) => {
    dispatch(selectOccupant(occupantData));
    navigate(
      `/project-home/occupanthomepage?projectId=${occupantData.id}&type=${projectType.occupant}`
    );
  };

  const subColumnData = [
    {
      title: "S.No.",
      dataIndex: "id",
      width: 80,
      render(value, record, index) {
        // const pageSize = innoTableConfigsecond.pageSize;
        const serialNumber = (currentPage - 1) * pageSize + index + 1;
        return <SC.ValueSpan>{serialNumber}</SC.ValueSpan>;
      },
    },
    {
      title: "Occupant Name",
      dataIndex: "occupantName",
      sorter: (a, b) => a.occupantName.localeCompare(b.occupantName),
      showSorterTooltip: { target: "sorter-icon" },
      sortDirections: ["ascend", "descend"],
      onCell: (record) => ({
        style: { width: "350px" },
      }),

      render(value, record) {
        const menuItems = [
          {
            id: 1,
            text: "Archive",
            onClick: () => alert("true"),
          },
          {
            id: 2,
            text: "Move",
            onClick: () => alert("true"),
          },
        ];
        return (
          <SC.PopoverContainer>
            <SC.ValueSpanp>{value}</SC.ValueSpanp>
          </SC.PopoverContainer>
        );
      },
    },
    {
      title: "Occupant No",
      dataIndex: "occupantNo",
      render(value, record, index) {
        return (
          <>
            <SC.ValueSpan>{value}</SC.ValueSpan>
          </>
        );
      },
    },
    {
      title: "Coordinator",
      dataIndex: "coordinatorName",
      render(value, record, index) {
        return (
          <>
            <SC.ValueSpan>{value}</SC.ValueSpan>
          </>
        );
      },
    },
    {
      title: "Coordinator Contact No",
      dataIndex: "coordinatorContact",
      render(value, record, index) {
        return (
          <>
            <SC.ValueSpan>{decryptCrypto(value)}</SC.ValueSpan>
          </>
        );
      },
    },
    {
      title: "Coordinator Email",
      dataIndex: "coordinatorEmail",
      render(value, record, index) {
        return (
          <>
            <SC.ValueSpan>{value}</SC.ValueSpan>
          </>
        );
      },
    },
    {
      title: "Created Date",
      dataIndex: "createOn",
      render(value, record, index) {
        return (
          <>
            <SC.ValueSpan>
              <TimezoneConverter time={value} />
            </SC.ValueSpan>
          </>
        );
      },
    },
  ];

  const tableConfig = {
    draggable: false,
    selection: false,
    expandable: true,
    addNew: false,
    search: false,
    // pagination: {
    //   pageSize: innoTableConfigsecond.pageSize,
    //   onChange: (page) => setCurrentPage(page),
    // },
    pagination: {
      current: currentPage, // current page number
      pageSize: pageSize, // page size state
      // pageSizeOptions: ["20", "50", "100"], // options shown in the dropdown
      showSizeChanger: true, // enable page size dropdown
      onChange: (page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize); // this is important to update
      },
    },
    action: false,
    divBorder: false,
    sno: false,
  };
  return (
    <>
      <SC.Container>
        <CustomTabs
          option={tabData}
          onChange={handleTabChange}
          selectedValue={selectedSubLevel}
        />

        <div style={{ borderTop: `1px solid ${theme.colors.bordertask}` }}>
          <SC.TableContainer>
            <InnoTable
              tableConfig={tableConfig}
              padding="8px"
              column={subColumnData}
              data={occupant}
              tableKey="Level"
              searchKeys={["name", "displayTemplate"]}
              loading={loading}
              onRow={(record) => ({
                onClick: (event) => {
                  setTimeout(() => {
                    if (!document.querySelector(".ant-image-preview-mask")) {
                      handleClick(record);
                    }
                  }, 100);
                },
              })}
            />
          </SC.TableContainer>
        </div>
      </SC.Container>
    </>
  );
};

export default OccupantLevels;
